// TODO: Migrate My Plans to Microapp

import {Component, Input, OnInit} from '@angular/core';
import {ServiceUsage, SubscriptionPlan} from '@ox/typings';

// This component is for non 30 day trial plans, which are for now exclusive to Cadillac.
@Component({
  selector: 'webu-special-trial',
  templateUrl: './special-trial.html'
})
export class SpecialTrialComponent implements OnInit {
  @Input () subscription : SubscriptionPlan;
  @Input () userRole : string;
  @Input () serviceUsage : ServiceUsage;
  @Input () isVehicleOverviewPage: boolean;
  activePlan : any;
  upcomingPlan : any;

  ngOnInit(): void {
    if (this.subscription?.activePlans){
      this.activePlan = this.subscription.activePlans[0];
    }
    if (this.subscription?.upcomingPlans && this.subscription.upcomingPlans.length > 0 ) {
      this.upcomingPlan = this.subscription.upcomingPlans[0];
    }
  }

}
